/*
 * @Author: dengxy 1148926496@qq.com
 * @Date: 2024-12-20 11:08:12
 * @LastEditors: dengxy 1148926496@qq.com
 * @LastEditTime: 2025-07-15 16:34:25
 * @FilePath: \frontend\src\locales\lang\en.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
export default {
	app: {
		lang: 'Language',
		layoutSetting: 'Layout settings',
		logoutButton: 'Sign out',
	},
	request: {
		loginExpired: 'The login status has expired. You can continue to stay on this page or log in again.',
		systemHint: 'system hint',
		logInAgain: 'Log in again',
		cancel: 'Cancel',
		invalidSession: 'Invalid session, or the session has expired, please log in again.',
		networkError: 'Backend interface connection abnormality',
		systemTimeout: 'System interface request timeout',
		systemInterfaceError: 'System interface {code} exception',
		downloadingData: 'Downloading data, please wait.',
		downloadingFileError: 'There was an error downloading the file, please contact the administrator!'
	},
	common: {
		searchButton: 'search',
		resetButton: 'reset',
		addButton: 'add',
		editButton: 'edit',
		copyButton:'copy',
		removeButton: 'delete',
		batchRemoveButton: 'batch Remove',
		detailButton: 'detail',
		productAccess:'product Type',
		firmwareManagement:'firmware Management',
		taskManagement:'task Management',
		firmwareName:'firmware Name',
		modelName:'model Name',
		functionName:'function Name',
		productType:'product Type',
		templateName:'template Name',
		documentName:'document Name',
		moduleName:'module Name',
		supplierName:'supplier Name',
		taskName:'task Name',
		saveButton:'save',
		draftButton:'draft',
		backInsert:'back Insert',
		beforeInsert:'before Insert',
		startTheExperience:'Start the experience',
		superExperience:'Superimposed experience',
		moveUp:'Move up',
		moveDown:'Move down',
		test:'Test'
	},
	test: {
		id: 'ID',
		name: 'Name',
		grand: 'Grand',
		handler: 'Handler',
		enterName: 'Enter name',
		enterId: 'Enter id'
	}
}
